import React from 'react'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import reducers from './store/reducers/rootReducer'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { CssBaseline, StyledEngineProvider } from '@mui/material'
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getFunctions } from 'firebase/functions'
import { loadReduxState } from './_helpers/localStorageHelper'
import theme from './theme'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import frLocale from 'date-fns/locale/fr'
import { ThemeProvider } from '@mui/styles'
import { getStorage } from 'firebase/storage'
import { BrowserRouter } from 'react-router-dom'
import { createRoot } from 'react-dom/client'


const app = initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebaseapp.com`,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.appspot.com`,
})
const auth = getAuth()
auth.languageCode = 'fr'
const db = getFirestore()
const functions = getFunctions(app, 'europe-west1')
const storage = getStorage(app)

const store = createStore(
  reducers,
  loadReduxState(),
  applyMiddleware(thunk.withExtraArgument({ auth, db, functions, storage })),
)

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <StyledEngineProvider injectFirst>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={frLocale}>
          <CssBaseline />
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </LocalizationProvider>
      </StyledEngineProvider>
    </ThemeProvider>
  </Provider>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
